import { TextValue } from '@shared/types';

export enum DiscountReasonsEnum {
    CLEAN_ROOM_PROCESSING_ERROR = 1,
    PROBE_DESIGN_REDESIGN_ISSUE = 2,
    FREE_TRIAL = 3,
    //IncorrectResults = 4, // FR4 - Incorrect Results
    PROBE_INVENTORY_ISSUE = 5,
    SUPPLIES_INVENTORY = 6,
    BETA_CUSTOMER = 7,
    VENDOR_ISSUE = 8,
    CREDIT_FROM_PREVIOUS_ORDER = 9,
    SOFTWARE_ISSUE = 10,
    OTHER = 11,
    LATE_RESULTS = 12,
    REFERRAL = 13,
    PREVIOUS_PROCESSED_SAMPLE = 14,
    SALES_LEAD_DEVELOPMENT = 15,
    LATE_TAG_CENTER_SHIPMENT = 16,
    MARK_CONTROL_SAMPLES_AS_FREE = 17,
    VOLUME_DISCOUNT = 18,
    PASSPORT_PROGRAM = 19,
    INSTITUTIONAL_PROGRAM_FREE_SAMPLES = 20,
    CUSTOMER_EXPERIENCE = 21,
    INCONSISTENT_RESULTS = 22,
}

export const DiscountReasonsText: { [key in DiscountReasonsEnum]: string } = {
    [DiscountReasonsEnum.CLEAN_ROOM_PROCESSING_ERROR]: 'FR1 - Clean Room Processing Error',
    [DiscountReasonsEnum.PROBE_DESIGN_REDESIGN_ISSUE]: 'FR2 - Probe Design/Redesign Issue',
    [DiscountReasonsEnum.FREE_TRIAL]: 'FR3 - Free Trial',
    [DiscountReasonsEnum.PROBE_INVENTORY_ISSUE]: 'FR5 - Probe Inventory Issue',
    [DiscountReasonsEnum.SUPPLIES_INVENTORY]: 'FR6 - Supplies Inventory',
    [DiscountReasonsEnum.BETA_CUSTOMER]: 'FR7 - Beta Customer',
    [DiscountReasonsEnum.VENDOR_ISSUE]: 'FR8 - Vendor Issue',
    [DiscountReasonsEnum.CREDIT_FROM_PREVIOUS_ORDER]: 'FR9 - Credit From Previous Order',
    [DiscountReasonsEnum.SOFTWARE_ISSUE]: 'FR10 - Software Issue',
    [DiscountReasonsEnum.OTHER]: 'FR11 - Other',
    [DiscountReasonsEnum.LATE_RESULTS]: 'FR12 - Late Results',
    [DiscountReasonsEnum.REFERRAL]: 'FR-13 - Referral',
    [DiscountReasonsEnum.PREVIOUS_PROCESSED_SAMPLE]: 'FR14 - Previously Processed Sample',
    [DiscountReasonsEnum.SALES_LEAD_DEVELOPMENT]: 'FR-15 - Sales Lead Development',
    [DiscountReasonsEnum.LATE_TAG_CENTER_SHIPMENT]: 'FR16 - Late TAG Center Shipment',
    [DiscountReasonsEnum.MARK_CONTROL_SAMPLES_AS_FREE]: 'FR17 - Mark Control Samples as free',
    [DiscountReasonsEnum.VOLUME_DISCOUNT]: 'FR18 - Volume Discount',
    [DiscountReasonsEnum.PASSPORT_PROGRAM]: 'FR19 - Passport Program',
    [DiscountReasonsEnum.INSTITUTIONAL_PROGRAM_FREE_SAMPLES]: 'FR20 - Institutional Program Free Samples',
    [DiscountReasonsEnum.CUSTOMER_EXPERIENCE]: 'FR21 - Customer Experience',
    [DiscountReasonsEnum.INCONSISTENT_RESULTS]: 'FR22 - Inconsistent Results',
};

export const ckmDiscountReasons: TextValue[] = [
    { text: 'FR1 - Clean Room Processing Error', value: DiscountReasonsEnum.CLEAN_ROOM_PROCESSING_ERROR },
    { text: 'FR2 - Probe Design/Redesign Issue', value: DiscountReasonsEnum.PROBE_DESIGN_REDESIGN_ISSUE },
    { text: 'FR3 - Free Trial', value: DiscountReasonsEnum.FREE_TRIAL },
    { text: 'FR5 - Probe Inventory Issue', value: DiscountReasonsEnum.PROBE_INVENTORY_ISSUE },
    { text: 'FR6 - Supplies Inventory', value: DiscountReasonsEnum.SUPPLIES_INVENTORY },
    { text: 'FR7 - Beta Customer', value: DiscountReasonsEnum.BETA_CUSTOMER },
    { text: 'FR8 - Vendor Issue', value: DiscountReasonsEnum.VENDOR_ISSUE },
    { text: 'FR9 - Credit From Previous Order', value: DiscountReasonsEnum.CREDIT_FROM_PREVIOUS_ORDER },
    { text: 'FR10 - Software Issue', value: DiscountReasonsEnum.SOFTWARE_ISSUE },
    { text: 'FR11 - Other', value: DiscountReasonsEnum.OTHER },
    { text: 'FR12 - Late Results', value: DiscountReasonsEnum.LATE_RESULTS },
    { text: 'FR-13 - Referral', value: DiscountReasonsEnum.REFERRAL },
    { text: 'FR14 - Previously Processed Sample', value: DiscountReasonsEnum.PREVIOUS_PROCESSED_SAMPLE },
    { text: 'FR-15 - Sales Lead Development', value: DiscountReasonsEnum.SALES_LEAD_DEVELOPMENT },
    { text: 'FR16 - Late TAG Center Shipment', value: DiscountReasonsEnum.LATE_TAG_CENTER_SHIPMENT },
    { text: 'FR18 - Volume Discount', value: DiscountReasonsEnum.VOLUME_DISCOUNT },
    { text: 'FR19 - Passport Program', value: DiscountReasonsEnum.PASSPORT_PROGRAM },
    {
        text: 'FR20 - Institutional Program Free Samples',
        value: DiscountReasonsEnum.INSTITUTIONAL_PROGRAM_FREE_SAMPLES,
    },
    { text: 'FR21 - Customer Experience', value: DiscountReasonsEnum.CUSTOMER_EXPERIENCE },
    { text: 'FR22 - Inconsistent Results', value: DiscountReasonsEnum.INCONSISTENT_RESULTS },
];

export const userDiscountReasons: TextValue[] = [
    { text: 'FR1 - Clean Room Processing Error', value: DiscountReasonsEnum.CLEAN_ROOM_PROCESSING_ERROR },
    { text: 'FR2 - Probe Design/Redesign Issue', value: DiscountReasonsEnum.PROBE_DESIGN_REDESIGN_ISSUE },
    { text: 'FR3 - Free Trial', value: DiscountReasonsEnum.FREE_TRIAL },
    { text: 'FR5 - Probe Inventory Issue', value: DiscountReasonsEnum.PROBE_INVENTORY_ISSUE },
    { text: 'FR6 - Supplies Inventory', value: DiscountReasonsEnum.SUPPLIES_INVENTORY },
    { text: 'FR7 - Beta Customer', value: DiscountReasonsEnum.BETA_CUSTOMER },
    { text: 'FR8 - Vendor Issue', value: DiscountReasonsEnum.VENDOR_ISSUE },
    { text: 'FR9 - Credit From Previous Order', value: DiscountReasonsEnum.CREDIT_FROM_PREVIOUS_ORDER },
    { text: 'FR10 - Software Issue', value: DiscountReasonsEnum.SOFTWARE_ISSUE },
    { text: 'FR11 - Other', value: DiscountReasonsEnum.OTHER },
    { text: 'FR12 - Late Results', value: DiscountReasonsEnum.LATE_RESULTS },
    { text: 'FR-13 - Referral', value: DiscountReasonsEnum.REFERRAL },
    { text: 'FR14 - Previously Processed Sample', value: DiscountReasonsEnum.PREVIOUS_PROCESSED_SAMPLE },
    { text: 'FR-15 - Sales Lead Development', value: DiscountReasonsEnum.SALES_LEAD_DEVELOPMENT },
    { text: 'FR16 - Late TAG Center Shipment', value: DiscountReasonsEnum.LATE_TAG_CENTER_SHIPMENT },
    { text: 'FR17 - Mark Control Samples as free', value: DiscountReasonsEnum.MARK_CONTROL_SAMPLES_AS_FREE },
    { text: 'FR18 - Volume Discount', value: DiscountReasonsEnum.VOLUME_DISCOUNT },
    { text: 'FR19 - Passport Program', value: DiscountReasonsEnum.PASSPORT_PROGRAM },
    {
        text: 'FR20 - Institutional Program Free Samples',
        value: DiscountReasonsEnum.INSTITUTIONAL_PROGRAM_FREE_SAMPLES,
    },
    { text: 'FR21 - Customer Experience', value: DiscountReasonsEnum.CUSTOMER_EXPERIENCE },
    { text: 'FR22 - Inconsistent Results', value: DiscountReasonsEnum.INCONSISTENT_RESULTS },
];
